import { Box } from '@mui/material';
import { Stack } from '@mui/system';
import { FC, ReactNode } from 'react';
import { GenderToggleButtonGroup } from 'src/components/molecules/ToggleButtonGroup/ToggleButtonGroupExtensions/GenderToggleButtonGroup';
import { ProductlineToggleButtonGroup } from 'src/components/molecules/ToggleButtonGroup/ToggleButtonGroupExtensions/ProductlineToggleButtonGroup';
import { useIsUsingGender, useIsUsingProductline } from 'src/hooks';
import { ActionButtons } from '../ActionButtons/ActionsButtons';
import { SmartModuleTitleCard } from '../SmartModuleTitleCard/SmartModuleTitleCard';
import { SmartTitleCard } from '../SmartTitleCard/SmartTitleCard';

interface Props {
    loading?: boolean;
    saveLoading?: boolean;
    saveDisabled?: boolean;
    saveTooltip?: string;
    discardTooltip?: string;
    setInheritanceDisabled?: boolean;
    resetDisabled?: boolean;
    discardDisabled?: boolean;
    hideToggleButtons?: boolean;
    hideButtons?: boolean;
    useModuleCard?: boolean;
    onDiscard?: () => unknown;
    onSave?: () => unknown;
    onReset?: () => unknown;
    onSetInheritance?: () => unknown;
    children?: ReactNode;
}

const Topbar: FC<Props> = ({
    loading,
    saveLoading,
    saveDisabled,
    saveTooltip,
    discardTooltip,
    setInheritanceDisabled,
    resetDisabled,
    discardDisabled,
    hideToggleButtons = false,
    hideButtons = false,
    useModuleCard = false,
    onDiscard,
    onSave,
    onReset,
    onSetInheritance,
    children,
}) => {
    const showGender = useIsUsingGender();
    const showProductline = useIsUsingProductline();
    const showButtons = (showGender || showProductline) && !hideToggleButtons;

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                width: '100%',
            }}
        >
            {useModuleCard ? <SmartModuleTitleCard /> : <SmartTitleCard />}
            {showButtons && (
                <Stack
                    direction={{ xs: 'column', sm: 'column', md: 'column', lg: 'row' }}
                    sx={{
                        gap: 4,
                        width: '100%',
                    }}
                >
                    {showProductline && <ProductlineToggleButtonGroup />}
                    {showGender && <GenderToggleButtonGroup />}
                </Stack>
            )}
            {children}
            {!hideButtons && (
                <ActionButtons
                    discardDisabled={discardDisabled}
                    saveDisabled={saveDisabled}
                    setInheritanceDisabled={setInheritanceDisabled}
                    resetDisabled={resetDisabled}
                    onDiscard={onDiscard}
                    onReset={onReset}
                    onSave={onSave}
                    onSetInheritance={onSetInheritance}
                    loading={loading}
                    saveLoading={saveLoading}
                    saveTooltip={saveTooltip}
                    discardTooltip={discardTooltip}
                />
            )}
        </Box>
    );
};

export default Topbar;
